import { render, staticRenderFns } from "./CourseResource.vue?vue&type=template&id=3efdafca&scoped=true"
import script from "./CourseResource.vue?vue&type=script&lang=js"
export * from "./CourseResource.vue?vue&type=script&lang=js"
import style0 from "./CourseResource.vue?vue&type=style&index=0&id=3efdafca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efdafca",
  null
  
)

export default component.exports